// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductsUI_view__dxr2w {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ProductsUI_loader__KagxX {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.ProductsUI_description__1Vx\\+W {
  width: 200px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ProductsUI_input__u9Xuj {
  background-color: #fbfbfb;
  border-color: #d2d2d2;
  border-radius: 4px;
  width: 300px;
}

.ProductsUI_menu__-a0\\+q{
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/suggets/styles/ProductsUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.description {\n  width: 200px;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.input {\n  background-color: #fbfbfb;\n  border-color: #d2d2d2;\n  border-radius: 4px;\n  width: 300px;\n}\n\n.menu{\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `ProductsUI_view__dxr2w`,
	"loader": `ProductsUI_loader__KagxX`,
	"description": `ProductsUI_description__1Vx+W`,
	"input": `ProductsUI_input__u9Xuj`,
	"menu": `ProductsUI_menu__-a0+q`
};
export default ___CSS_LOADER_EXPORT___;
